import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiClientsOnboardingsService() {
  return fetch(`clients/onboardings`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
